module.exports = __webpack_public_path__ + "static/proxy-extension-picture-54e4c8b932ed4eb8b356591b6a07c4e1.png";